import { createContext } from 'react';

export const SensorContext = createContext(null);
export const JsonTabContext = createContext(null);
